export default __webpack_public_path__ + "static/media/koc_ortak_ofis.c588be1a.svg";